import React from 'react';
import styles from './footer.module.css';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';

const { Footer: AntFooter } = Layout;

const Footer = () => {
  return (
    <AntFooter className={styles.footer}>
      {/* © {new Date().getFullYear()} NextZenMinds. All rights reserved. */}
      {/* <span>Powered by:</span>&nbsp;
      <Link to="" target='_blank'></Link> */}
    </AntFooter>
  );
};
export default Footer;
